import { Pagination, Stack, Table } from 'rsuite';
import GroupDropdown from './GroupDropdown';
import { GroupSearch } from './GroupSearch';
import { useEffect, useState } from 'react';
import {
  selectHaGroups,
  selectHaCurrentGroup,
  updateHaCurrentGroup
} from '@monorepo/shared/store/groupSlice';
import {
  useAppDispatch,
  useAppSelector,
  useGroupAccountsByPageQuery
} from '@monorepo/shared';
import { updateCurrentAccount } from '@monorepo/shared/store/accountSlice';
import { useNavigate } from 'react-router-dom';

export const GroupAccounts = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { Column, HeaderCell, Cell } = Table;
  const groups = useAppSelector(selectHaGroups);
  const currentHaGroup = useAppSelector(selectHaCurrentGroup);
  const limits = [10, 20, 50, 100];
  const [limit, setLimit] = useState<number>(limits[0]);
  const [page, setPage] = useState<number>(1);
  const [sortColumn, setSortColumn] = useState<string>('account_id');
  const [sortType, setSortType] = useState<any>('asc');
  const [tableData, setTableData] = useState<Record<string, any>[]>([]);
  const [SearchObj, setGroupSearchObj] = useState<Record<string, string>>({});
  const handleChangeLimit = (pageSize: number) => {
    setPage(1);
    setLimit(pageSize);
  };
  const handleSortColumn = (sortColumn: any, sortType: any) => {
    setSortColumn(sortColumn);
    setSortType(sortType);
  };
  const { data, isLoading, isError, isFetching } = useGroupAccountsByPageQuery(
    {
      groupId: currentHaGroup?.id,
      page: page,
      pageSize: limit,
      sortColumn: sortColumn,
      sortType: sortType,
      regionObj: currentHaGroup?.regionObj,
      searchObj: SearchObj
    },
    {
      skip: !currentHaGroup?.regionObj?.token
    }
  );
  useEffect(() => {
    const filteredData = [
      ...new Map<string, Record<string, any>>(
        data?.data?.results.map((o: Record<string, any>) => [o.account_id, o])
      ).values()
    ];
    setTableData(filteredData);
  }, [data]);

  const goToAccount = (rowData: Record<string, any>) => {
    dispatch(updateCurrentAccount(rowData));
    navigate(`/group/accounts/${currentHaGroup.id}/${rowData.account_id}`);
  };

  useEffect(() => {
    if (groups && Object.keys(groups).length) {
      const firstOne = Object.values(groups)?.[0];
      if (!currentHaGroup?.id) {
        dispatch(updateHaCurrentGroup(firstOne));
      }
    }
  }, [groups]);

  useEffect(() => {
    setPage(1);
  }, [currentHaGroup]);

  return (
    <div className="group-accounts">
      <Stack spacing={20}>
        <GroupDropdown />
        <Stack.Item flex={1}>
          <GroupSearch setGroupSearchObj={setGroupSearchObj} />
        </Stack.Item>
      </Stack>
      <div className="table-container">
        <Table
          fillHeight
          data={tableData}
          loading={isLoading || isFetching}
          sortColumn={sortColumn}
          sortType={sortType}
          headerHeight={32}
          rowHeight={37}
          onSortColumn={handleSortColumn}
        >
          <Column flexGrow={1} sortable>
            <HeaderCell>Account ID</HeaderCell>
            <Cell dataKey="account_id">
              {(rowData) => {
                return (
                  <div
                    className="account-id-link"
                    onClick={() => goToAccount(rowData)}
                  >
                    {rowData.account_id}
                  </div>
                );
              }}
            </Cell>
          </Column>

          <Column flexGrow={1} sortable>
            <HeaderCell>Company</HeaderCell>
            <Cell dataKey="account_company" />
          </Column>

          <Column flexGrow={1} sortable>
            <HeaderCell>Owner</HeaderCell>
            <Cell dataKey="master_user_name" />
          </Column>
          <Column flexGrow={1} sortable>
            <HeaderCell>Email</HeaderCell>
            <Cell dataKey="account_email" />
          </Column>
        </Table>
        <div style={{ padding: 20 }}>
          <Pagination
            prev
            next
            first
            last
            ellipsis
            boundaryLinks
            maxButtons={5}
            size="xs"
            layout={['total', '-', 'limit', '|', 'pager', 'skip']}
            total={data?.data?.count}
            limitOptions={[10, 30, 50]}
            limit={limit}
            activePage={page}
            onChangePage={setPage}
            onChangeLimit={handleChangeLimit}
          />
        </div>
      </div>
    </div>
  );
};
